import React from 'react';
import { string } from 'prop-types';
import { Col, Heading, Row } from '@thd-olt-component-react/core-ui';

const CarouselHeader = ({ title }) => (
  <Row>
    <Col>
      <Heading title={title} underline />
    </Col>
  </Row>
);

CarouselHeader.propTypes = {
  title: string
};

CarouselHeader.defaultProps = {
  title: ''
};

export { CarouselHeader };